module.exports = __webpack_public_path__ + "static/media/task_manager.58696984.png";